module.exports = __webpack_public_path__ + "static/img/tax_saas_content.d339828.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/matrix/tax_saas_content.png
// module id = Mv6H
// module chunks = 34